<template>
  <div>
    <v-card
      class="hide-overflow"
      :style="viewTransferPage ? '' : 'min-height: 100vh'"
    >
      <div style="width: 100%; height: 64px" v-if="isSeagull">
        <merchant-detail v-model="pageProfile"></merchant-detail>
      </div>
      <v-toolbar color="transparent" flat>
        <v-btn
          icon
          @click="$emit('onClose')"
          :disabled="loadingCheckout"
          v-if="!isCDS && pageProfile.type != 'chillpainai'"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          isSeagull ? $t('shoppping_cart') : $t('Checkout Cart')
        }}</v-toolbar-title>
      </v-toolbar>
      <div v-if="$route.query.shoptoken">
        <v-alert :value="true" type="warning">
          {{ $t('create_order_by_admin') }}
        </v-alert>
      </div>
      <div :style="paddingFooter" :class="{ extra: isFoodguru }">
        <template v-if="loadingCart">
          <div class="text-xs-center">
            <v-progress-circular
              :key="theme.color"
              indeterminate
              :color="theme.color"
            ></v-progress-circular>
          </div>
        </template>
        <template v-else-if="cart && filterBundles.length > 0">
          <template v-for="(bundle, bindex) in filterBundles">
            <template v-if="bundle.id != 'other'">
              <BundleGroup :key="bundle.id" :bundle="bundle">
                <template v-slot:title-append>
                  <v-btn
                    small
                    flat
                    color="orange"
                    @click="handleShowBundleOption(bundle)"
                  >
                    เลือกสินค้าเพิ่ม >
                  </v-btn>
                </template>
                <template v-for="(product, pindex) in bundle.filterCart">
                  <checkout-item
                    :viewTransferPage="viewTransferPage"
                    :categories="filterCategory"
                    :key="'cart_' + bindex + '_' + pindex + '_' + timestamp"
                    :value="product"
                    :loading="loadingCheckout"
                    @deleteItem="$emit('onDeleteItemInCart', product.rand_id)"
                    @onUpdateStock="$emit('onUpdateStock')"
                    @showProduct="showProduct"
                    @onChangeAddon="
                      $emit('onChangeAddon', product.rand_id, $event)
                    "
                    :stock="
                      products[product.id]
                        ? products[product.id].productstock
                        : []
                    "
                  ></checkout-item>
                </template>
              </BundleGroup>
              <v-divider
                v-if="bindex != filterBundles.length - 1"
                :key="`divider_${bundle.id}`"
              />
            </template>
            <template v-else>
              <Pagination v-model="bundle.filterCart" :key="bundle.id">
                <template v-slot="{ item, index, pageNumber }">
                  <checkout-item
                    :viewTransferPage="viewTransferPage"
                    :categories="filterCategory"
                    :key="'cart_' + bindex + '_' + index + '_' + timestamp"
                    :value="item"
                    :loading="loadingCheckout"
                    @deleteItem="
                      $emit('onDeleteItemInCart', item.rand_id, pageNumber)
                    "
                    @onUpdateStock="$emit('onUpdateStock')"
                    @showProduct="showProduct"
                    @onChangeAddon="
                      $emit('onChangeAddon', item.rand_id, $event)
                    "
                    :stock="
                      products[item.productid]
                        ? products[item.productid].productstock
                        : []
                    "
                  ></checkout-item>
                </template>
              </Pagination>
            </template>
          </template>
        </template>
        <template v-else>
          <div class="text-xs-center pt-4 pb-4">
            <p>{{ $t('No product') }}</p>
          </div>
        </template>
      </div>
      <div
        class="text-xs-center mt-3"
        v-if="$route.query.shoptoken && !viewTransferPage"
      >
        <template
          v-if="
            isCartOutOfStock ||
            (filterCart.length < 1 && $route.query.shoptoken)
          "
        >
          <div class="text-xs-center pa-3 grey lighten-2">
            <span>
              {{
                $t('Not enough products in stock, please try to order again.')
              }}
            </span>
          </div>
        </template>
        <template v-else-if="minimumBuy.value">
          <!-- <template v-if="cart.length < 1 || isCartOutOfStock"> -->
          <div class="text-xs-center pa-3 grey lighten-2">
            <span>
              {{ $t('Please order a minimum amount of') }}
              {{ minimumBuy.price }}
              {{ $t('baht') }}
            </span>
          </div>
        </template>
        <v-btn
          depressed
          large
          dark
          ripple
          :color="theme.color"
          :disabled="isCartOutOfStock || minimumBuy.value"
          :loading="loadingCart || loadingCheckout || loadingPageProfile"
          class="mb-4 mt-4"
          @click="handleCheckout"
        >
          <v-icon>mdi-cart-plus</v-icon>&nbsp;
          <template>{{ $t('create_order') }}</template>
        </v-btn>
      </div>
      <template v-else>
        <v-card
          style="position: fixed; z-index: 3; bottom: 0; left: 0; right: 0"
          v-if="!viewTransferPage"
        >
          <v-layout wrap>
            <v-flex
              xs12
              v-if="['foodguru'].includes(pageProfile.type)"
              class="pl-3 pt-2"
            >
              <a href="javascript:void(0);" @click="showShippingFeeFoodguru()">
                <span
                  style="
                    letter-spacing: 0;
                    color: #f41818;
                    font-size: 16px;
                    text-decoration: underline;
                  "
                  >เงื่อนไขค่าจัดส่ง</span
                >
              </a>
            </v-flex>

            <div v-if="isSeagull" class="seagull-footer">
              <div
                style="
                  position: absolute;
                  left: 0;
                  top: -56px;
                  width: 100%;
                  background: #fff;
                  text-align: left;
                "
              >
                <v-card
                  style="
                    border-top: 1px solid #eee;
                    border-bottom: 1px solid #eee;
                  "
                  elevation="0"
                >
                  <v-layout wrap style="height: 100%">
                    <v-flex
                      sm9
                      style="display: flex"
                      align-center
                      justify-end
                      class="pr-3"
                    >
                      <template v-if="filterCart.length >= 1">
                        <span
                          class="black--text pr-3"
                          style="font-size: 16px"
                          >{{ $t('total_1') }}</span
                        >
                        <span class="primary--text" style="font-size: 20px">
                          {{ currencySign }} {{ totalPrice | decimalFormat }}
                        </span>
                      </template>
                    </v-flex>
                    <v-flex sm3>
                      <v-btn
                        depressed
                        dark
                        ripple
                        :color="theme.color"
                        :loading="
                          loadingCart || loadingCheckout || loadingPageProfile
                        "
                        @click="handleCheckout"
                        class="ma-0"
                        :disabled="isCartOutOfStock || minimumBuy.value"
                        style="width: 100%; border-radius: 0px; height: 55px"
                        :style="{
                          'padding-bottom': $store.getters.getIosPadding
                            ? '15px'
                            : '0'
                        }"
                      >
                        {{ $t('Payment') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </div>
              <div>
                <div>บริษัท ไทยสเตนเลสสตีล จำกัด</div>
                <div>&copy; 2023 Thai Stainless Steel Co., Ltd.</div>
              </div>
            </div>
            <template v-else>
              <template v-if="filterCart.length >= 1">
                <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">{{
                  $t('Total')
                }}</v-flex>
                <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2 text-xs-right"
                  >{{ currencySign }}{{ totalPrice | decimalFormat }}</v-flex
                >
              </template>

              <v-flex
                v-if="$store.state.newCentralPage.includes(pageProfile.pageid)"
                xs6
                style="border-right: 1px solid #fff"
              >
                <v-btn
                  depressed
                  large
                  dark
                  ripple
                  :color="theme.color"
                  :loading="
                    loadingCart || loadingCheckout || loadingPageProfile
                  "
                  class="ma-0"
                  style="width: 100%; border-radius: 0px; height: 55px"
                  :style="{
                    'padding-bottom': $store.getters.getIosPadding
                      ? '15px'
                      : '0'
                  }"
                  @click="$emit('checkout', true, true)"
                >
                  <v-icon>mdi-cart-plus</v-icon>&nbsp;
                  <template>{{ $t('Update basket') }}</template>
                </v-btn>
              </v-flex>
              <v-flex
                :xs6="$store.state.newCentralPage.includes(pageProfile.pageid)"
                :xs12="
                  !$store.state.newCentralPage.includes(pageProfile.pageid)
                "
              >
                <template
                  v-if="
                    isCartOutOfStock ||
                    (filterCart.length < 1 && $route.query.shoptoken)
                  "
                >
                  <div class="text-xs-center pa-3 grey lighten-2">
                    <span>
                      {{
                        $t(
                          'Not enough products in stock, please try to order again.'
                        )
                      }}
                    </span>
                  </div>
                </template>
                <template v-else-if="isBevita">
                  <div class="text-xs-center pa-3 grey lighten-2">
                    <span>
                      {{ $t('only_one_item_can_be_purcahsed') }}
                    </span>
                  </div>
                </template>
                <template v-else-if="minimumBuy.value">
                  <!-- <template v-if="cart.length < 1 || isCartOutOfStock"> -->
                  <div class="text-xs-center pa-3 grey lighten-2">
                    <span>
                      {{ $t('Please order a minimum amount of') }}
                      {{ minimumBuy.price }}
                      {{ $t('baht') }}
                    </span>
                  </div>
                </template>
                <v-btn
                  v-else
                  depressed
                  large
                  dark
                  ripple
                  :color="theme.color"
                  :loading="
                    loadingCart || loadingCheckout || loadingPageProfile
                  "
                  @click="handleCheckout"
                  class="ma-0"
                  :disabled="isCartOutOfStock || minimumBuy.value"
                  style="width: 100%; border-radius: 0px; height: 55px"
                  :style="{
                    'padding-bottom': $store.getters.getIosPadding
                      ? '15px'
                      : '0'
                  }"
                >
                  <v-icon>{{
                    $store.state.newCentralPage.includes(pageProfile.pageid)
                      ? 'mdi-cash-multiple'
                      : 'mdi-cart-plus'
                  }}</v-icon
                  >&nbsp;
                  <template
                    v-if="$store.state.cds.includes(pageProfile.pageid)"
                    >{{ $t('Payment') }}</template
                  >
                  <template v-else>
                    {{
                      $store.state.newCentralPage.includes(pageProfile.pageid)
                        ? $t('Go to checkout')
                        : isNestle
                        ? 'ดำเนินการต่อ'
                        : $store.getters.isPowerBuyPage
                        ? 'สนใจสินค้ากดเลย'
                        : $t('Proceed Checkout')
                    }}</template
                  >
                </v-btn>
              </v-flex>
            </template>
          </v-layout>
        </v-card>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/Pagination'
import CheckoutItem from '@/components/ecommerce/CheckoutItem.vue'
import BundleGroup from '@/components/ecommerce/Bundles/BundleGroup.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'

export default {
  props: {
    viewTransferPage: {
      default: false
    },
    isCDS: {
      default: false
    },
    isFoodguru: {
      default: false
    },
    loadingCart: {
      default: true
    },
    loadingCheckout: {
      default: false
    },
    products: {
      default: {}
    },
    filterCart: {
      default: []
    },
    filterCategory: {
      default: []
    },
    timestamp: {
      default: null
    },
    onlyOneQuantity: {
      default: false
    }
  },
  components: {
    Pagination,
    CheckoutItem,
    BundleGroup,
    MerchantDetail
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      currencySign: 'currencySign'
    }),
    isBevita() {
      const vm = this
      let count = 0
      // Bevita ซื้อได้เพียง 1 ชิ้นต่อครั้ง
      vm.cart.forEach((item) => {
        if ([8746929, 8746930, 8746931].includes(item.id)) {
          count += item.quantity
        }
      })
      //117242674652029 เพจเทส Bevita
      if (
        (['117242674652029'].includes(vm.pageProfile.pageid) && count > 1) ||
        vm.onlyOneQuantity
      ) {
        return true
      } else {
        return false
      }
    },

    isNestle() {
      return this.pageProfile && ['nestle'].includes(this.pageProfile.type)
    },

    isCartOutOfStock: function () {
      return (
        this.filterCart.filter(function (el) {
          if (el.optionDetail == null) {
            return true
          } else {
            return (
              parseInt(el.optionDetail[2]) + parseInt(el.adjust_qty || 0) <
              el.quantity
            )
          }
        }).length > 0
      )
    },
    minimumBuy() {
      if (
        ['324885161495477', '103195847822433'].includes(
          this.pageProfile.pageid
        ) &&
        this.totalPrice < 500
      ) {
        return { value: true, price: 500 }
      } else if (
        ['108209024822196'].includes(this.pageProfile.pageid) &&
        this.totalPrice < 100
      ) {
        return { value: true, price: 100 }
      } else {
        return { value: false, price: 0 }
      }
    },
    totalPrice: function () {
      let vm = this
      if (vm.voucher) {
        return vm.voucher.lasttotal
      }
      if (vm.filterCart && vm.filterCart.length > 0) {
        let total = 0
        try {
          total = vm.filterCart.reduce((prev, curr) => {
            if (curr.optionDetail) {
              if (parseInt(curr.optionDetail[2]) >= curr.quantity) {
                prev += curr.bundleprice
              }
            }
            if (
              this.pageProfile.type == 'reka' &&
              curr.addon_json.embroideredNameList &&
              curr.addon_json.embroideredNameList.length > 0
            ) {
              //
              let embroideredNameList =
                curr.addon_json.embroideredNameList.filter((el) => {
                  return el || el != ''
                })
              if (embroideredNameList.length > 0)
                prev += embroideredNameList.length * 100
            }
            return prev
          }, 0)
        } catch (error) {
          //
        }

        return total
      } else {
        return 0
      }
    },

    filterBundles() {
      const vm = this
      let cart =
        vm.$route.query && vm.$route.query.shoptoken && vm.viewTransferPage
          ? [...vm.carts]
          : [...vm.cart]
      const bundles = vm.$store.getters['bundles/availableBundles']
      return vm.getMatchBundleGroup(bundles, cart)
    },
    isSeagull() {
      return this.pageProfile && ['seagull'].includes(this.pageProfile.theme)
    },
    paddingFooter() {
      let padding = ''

      if (!this.$route.query.shoptoken) {
        if (this.voucher) {
          padding = {
            'padding-bottom': '200px'
          }
        } else if (this.isSeagull) {
          padding = {
            'padding-bottom': '130px'
          }
        }
      } else {
        padding = {
          'padding-bottom': '100px'
        }
      }

      return padding
    }
  },
  data() {
    return {
      voucher: null,
      carts: []
    }
  },
  mounted() {},
  methods: {
    handleShowBundleOption(bundle) {
      this.$store.commit('bundles/SHOW_BUNDLE_SELECT', bundle)
      this.$emit('onClose')
    },
    showProduct(productid) {
      var product = this.productlist.find((el) => {
        return el.id == productid
      })
      if (product) {
        var newProduct = { ...product }
        newProduct.showBack = true
        this.$emit('onSelectProduct', newProduct)
      }
    },
    async handleCheckout() {
      const vm = this
      if (vm.$route.query && vm.$route.query.shoptoken) {
        let cart = null
        cart = JSON.stringify(vm.cart)
        vm.carts = JSON.parse(cart)
      }
      if (
        vm.pageProfile &&
        vm.pageProfile.useketshop == true &&
        vm.pageProfile.ketshop_api_key &&
        vm.pageProfile.ketshop_api_secret
      ) {
        let result = await vm.$swal({
          title: vm.$t(
            'if_you_confirm_to_proceed_with_payment_you_will_not_be_able_to_modify_this_order_again'
          ),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('Cancel'),
          showCancelButton: true,
          reverseButtons: true
        })
        if (result.value) {
          vm.$emit('checkout', true)
        }
      } else {
        vm.$emit('checkout', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
